import { render, staticRenderFns } from "./reasonsForReportBarChart.vue?vue&type=template&id=a71f7a3c"
import script from "./reasonsForReportBarChart.vue?vue&type=script&lang=js"
export * from "./reasonsForReportBarChart.vue?vue&type=script&lang=js"
import style0 from "./reasonsForReportBarChart.vue?vue&type=style&index=0&id=a71f7a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports